import React from 'react';
import { Button } from '@mui/material';

export const OutlinedButton = ({ title, icon, onClick, disabled }) => {
  return (
    <Button variant="outlined"
            startIcon={<img src={icon} alt='icon'/>}
            style={{ border: '2px solid' }}
            onClick={onClick}
            disabled={disabled}
    >
      {title}
    </Button>
  )
};